import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import { toast } from "react-toastify";
import { useRouter } from "next/router";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { collection, doc, getDocs, query, setDoc, where } from "firebase/firestore/lite";
import { firebaseFireStore } from "../../config/firebaseFirestore";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CreateNewCollectionDialog(props) {
  const classes = useStyles();
  const [loading, setloading] = useState(false);

  const dispatch = useDispatch();
  const router = useRouter();
  const userDataRedux = useSelector((state) => state.authReducer.userData);

  const [collectionNameField, setcollectionNameField] = useState("");

  const handleClose = () => {
    props.setdialogState(false);
  };

  const createCollection = async (e) => {
    e.preventDefault();
    // trim the value before creating the collection (MusicA-333)
    const val = collectionNameField.trim();
    setloading(true);

    //checking collection uniquness
    let isUnique = false;
    const q = query(collection(firebaseFireStore, "musicartCollections"), 
    where("name", "==", val.toLowerCase()));
 
    let dbRef = await getDocs(q);


    if (dbRef.empty) {
      isUnique = true;
    }

    try {
      if (!isUnique) {
        setloading(false);
        toast.error("Collection already exists!", {
          position: "bottom-left",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        //creating new collection
        let collectionId = uuidv4();
        let obj = {
          id: collectionId,
          displayName: val,
          name: val.toLowerCase(),
          creator: props.userId,
        };
        await setDoc(doc(firebaseFireStore, "musicartCollections", collectionId), obj);


        props.setsellerCollections([...props.sellerCollections, obj]);
        props.setCollectionVal(val);
        toast.success("Collection created successfully!", {
          position: "bottom-left",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setloading(false);
        setcollectionNameField("");
        handleClose();
      }
    } catch (err) {
      // console.log("catch err", err);
      toast.error(err.message, {
        position: "bottom-left",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });

      setloading(false);
      return "error";
    }
  };

  return (
    <Dialog
      open={props.dialogState}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      style={{ zIndex: 1000 }}
      maxWidth="sm"
      onClose={handleClose}
    >
      <h5
        className="text-lg font-semibold"
        style={{ padding: "18px 24px 10px 24px" }}
      >
        Create New Collection
      </h5>
      <div className="dialog-close-medium">
        <button
          className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
          type="button"
          onClick={handleClose}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <DialogContent>
        <form onSubmit={createCollection}>
          <div className="row">
            <div className="w-full">
              <div className="sign__group mt-1">
                <label className="sign__label" htmlFor="collectionNameField">
                  Collection name <span className="text-red-500">*</span>
                </label>
                <input
                  id="collectionNameField"
                  type="text"
                  name="itemname"
                  className="sign__input"
                  placeholder="e.g. 'limited edition'"
                  required
                  value={collectionNameField}
                  onChange={(e) => {
                    setcollectionNameField(e.target.value);
                  }}
                />
                {collectionNameField && collectionNameField.length > 0 && (
                  <button
                    type="button"
                    onClick={() => {
                      setcollectionNameField("");
                    }}
                    className="close_icon"
                  >
                    <HighlightOffIcon />
                  </button>
                )}
              </div>
            </div>

            <div
              style={{
                minWidth: 100,
                textAlign: "center",
                marginBottom: 5,
                marginTop: 20,
              }}
            >
              {(() => {
                if (loading) {
                  return (
                    <div className="flex justify-center	">
                        <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                    </div>
                  );
                } else {
                  return (
                    <button
                      className="bg-blueGray-700 active:bg-blueGray-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                      type="submit"
                    >
                      Create
                    </button>
                  );
                }
              })()}
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}

const useStyles = makeStyles(() => ({
  selectEle: {
    minWidth: 150,
  },
}));
